module.exports = __webpack_public_path__ + "static/media/pro.1232f3eb.svg";